export enum DocumentType {
  PASSPORT = 1,
  ID = 2,
  OTHER = 11,
}

export enum CorrespondenceMethod {
  EMAIL = 1,
  POST_OFFICE = 2,
}

export enum DataUploadMethod {
  MANUAL = 1,
  DIGITAL = 2,
  MOBILE = 3,
}

export enum Device {
  MOBILE = 1,
  DESKTOP = 2,
}

export enum NoTinReason {
  NOT_ISSUED = 1,
  UNABLE_TO_GET = 2,
  OTHER = 3,
}

export enum Currency {
  PLN = 1,
  EUR = 2,
  USD = 3,
  CZK = 4,
}

export enum PaymentType {
  BLUE_MEDIA = 1,
  TRUSTLY = 2,
}

export enum DataUserDeclaration {
    NON_PROFESSIONAL = 'NON_PROFESSIONAL_DATA_USER_DECLARATION',
    PROFESSIONAL = 'PROFESSIONAL_DATA_USER_DECLARATION',
}

export enum EmploymentStatus {
  EMPLOYED = "EMPLOYED",
  SELF_EMPLOYED = "SELF_EMPLOYED",
  BUSINESS_OWNER = "BUSINESS_OWNER",
  UNEMPLOYED = "UNEMPLOYED",
  RETIRED = "RETIRED",
  STUDENT_EMPLOYED = "STUDENT_WITH_EMPLOYMENT",
  STUDENT_UNEMPLOYED = "STUDENT_WITHOUT_EMPLOYMENT"
}

export enum NatureOfBusiness {
  AGRICULTURAL = 'AGRICULTURAL',
  EDUCATION = "EDUCATION",
  SOCIAL_SERVICES_HEALTH = "SOCIAL_SERVICES_HEALTH",
  FINANCIAL_LEGAL_ACCOUNTING = "FINANCIAL_LEGAL_ACCOUNTING",
  RETAIL_SERVICES = "RETAIL_SERVICES",
  ADMINISTRATIVE = "ADMINISTRATIVE",
  INSURANCE_SERVICE = "INSURANCE_SERVICES",
  ENGINEERING_IT_TECHNOLOGY = "ENGINEERING_IT_TECHNOLOGY",
  RESTAURANTS = "RESTAURANTS",
  TRANSPORT_LOGISTICS = "TRANSPORT_LOGISTICS",
  AUTOMOTIVE = "AUTOMOTIVE",
  CASINO_BETTING = "CASINO_BETTING",
  NON_PROFIT_CHARITY = "NOT_PROFIT_CHARITY",
  DEFENCE_MILITARY_AEROSPACE = "DEFENCE_MILITARY_AEROSPACE",
  LEISURE_TOURISM = "LEISURE_TOURISM",
  MINING_NATURAL_RESOURCES_OIL = "MINING_NATURAL_RESOURCES_OIL",
  PHARMACEUTICALS_BIOTECH = "PHARMACEUTICALS_BIOTECH",
  PROPERTY_CONSTRUCTION = "PROPERTY_CONSTRUCTION",
  EXPORT_IMPORT = "EXPORT_IMPORT",
  SALE_DISTRIBUTION_ALCOHOL_TOBACCO = "SALE_DISTRIBUTION_OF_ALCOHOL_TOBACCO",
  MANUFACTURING = "MANUFACTURING",
  MARKETING = "MARKETING"
}

export enum Role {
  JUNIOR = "JUNIOR_EMPLOYEE",
  MID ="MID_LEVEL_EMPLOYEE",
  SENIOR = "SENIOR_EMPLOYEE",
  MANAGER_DIRECTOR = "MANAGER_DIRECTOR",
  CONTRACTOR = "PROFESSIONAL_CONTRACTOR"
}

export enum SourceOfFunds {
  EMPLOYMENT_INCOME = "EMPLOYMENT",
  BUSINESS_ACTIVITY = "BUSINESS_ACTIVITY",
  PENSION = "PENSION",
  SAVINGS_INVESTMENTS = "SAVINGS_INVESTMENTS",
  GRANTS_LOANS = "GRANTS_LOANS_ETC"
}

export enum Income {
  EUR0 = "BELOW_10K_EUR",
  EUR10 = "10K_TO_16K_EUR",
  EUR16 = "16K_TO_30K_EUR",
  EUR30 = "30K_TO_60K_EUR",
  EUR60 = "60K_TO_100K_EUR",
  EUR100 = "100K_TO_250K_EUR",
  EUR250 = "ABOVE_250K_EUR"
}

export enum Savings {
  EUR0 = "BELOW_10K_EUR",
  EUR10 = "10K_TO_16K_EUR",
  EUR16 = "16K_TO_30K_EUR",
  EUR30 = "30K_TO_60K_EUR",
  EUR60 = "60K_TO_100K_EUR",
  EUR100 = "100K_TO_250K_EUR",
  EUR250 = "ABOVE_250K_EUR"
}